/* import __COLOCATED_TEMPLATE__ from './add-tag-to-conversation-empty-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();